/*                                     */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
import { PREFIX } from "../lib/tracking/index.js";
export * from "../lib/tracking/index.js";
export * from "../lib/tracking/event/event.types.js";
/**
 *
 *
 */
export const tracking = asExport(otto, PREFIX, {});
/**
 *
 *
 *
 */
export const onInit = asExport(tracking, "onInit", {});
/**
 *
 *
 *
 *
 */
export const lockInit = asExport(tracking, "lockInit", noop);
/**
 *
 *
 *
 *
 */
export const unlockInit = asExport(tracking, "unlockInit", noop);
